import baseApi from './base';

const fetchAll = () =>
  baseApi.request({
    method: 'get',
    url: '/dictionaries'
  });

const modifyOne = data =>
  baseApi.request({
    method: 'patch',
    url: `/dictionaries/${data.id}`,
    data
  });

const createOne = data =>
  baseApi.request({
    method: 'post',
    url: '/dictionaries',
    data
  });

const deleteOne = id =>
  baseApi.request({
    method: 'delete',
    url: `dictionaries/${id}`
  });

export {
  fetchAll,
  modifyOne,
  createOne,
  deleteOne
};



// WEBPACK FOOTER //
// ./src/api/dictionary.js